import {
  UI_UPDATE_MASTER_DATA,
  UI_SET_LOADER,
  UI_UPDATE_FROM_OFFER,
  SET_UI_PROPERTY
} from 'store/actions/ui';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_UI_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [UI_UPDATE_MASTER_DATA]: (state, data) => {
    const { streetType, maritalStatus, profession, sex, signType } = data;
    state.streetType = streetType;
    state.maritalStatus = maritalStatus;
    state.profession = profession;
    state.sex = sex;
    state.signType = signType;
  },

  [UI_SET_LOADER]: (state, loading) => {
    state.loader = loading;
  },

  [UI_UPDATE_FROM_OFFER]: (state, data) => {
    const {
      theme,
      logoFrontLeft,
      logoFrontRight,
      footerLogos,
      footerPubli,
      disclaimer,
      urlFooterLastStep
    } = data;
    state.headerLogos = {
      logoFrontLeft,
      logoFrontRight
    };
    state.footerLogos = footerLogos;
    state.footerPubli = footerPubli;
    state.urlFooterLastStep = urlFooterLastStep;
    state.disclaimer = disclaimer;
    if (theme) state.theme = theme;
  }
};
